import React from "react";
import { Box, Text, Tag, Icon, useDisclosure } from "@chakra-ui/react";
import { titleSize } from "src/api";
import { FormattedMessage } from "react-intl";
import { FaVideo } from "react-icons/fa6";
import TutorialModal from "../TutorialModal/TutorialModal";
import { useVideoTutorials } from "src/hooks/useVideoTutorials";

interface SectionHeaderProps {
  slug: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ slug }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { data: tutorialMap } = useVideoTutorials();
  const videoUrl = tutorialMap?.[slug] ?? null;

  return (
    <Box py={2}>
      <Box d="flex" alignItems="end" gap={2}>
        <Box>
          <Text
            as="h2"
            textStyle={"h2"}
            fontSize={titleSize}
            fontWeight="bold"
            color="#1f3f93"
            fontFamily={"Calibri (Body)"}
          >
            <FormattedMessage id={slug} />
          </Text>
          {videoUrl && (
            <Tag
              backgroundColor="#EFEFEF"
              cursor="pointer"
              onClick={onOpen}
              _hover={{
                backgroundColor: "#E0E0E0",
                transform: "scale(1.05)",
                transition: "all 0.2s ease",
              }}
            >
              <Icon as={FaVideo} marginRight="2" color="#1f3f93" />
              <Text color="#1f3f93">
                <FormattedMessage id="video_tutorial" />
              </Text>
            </Tag>
          )}
        </Box>
      </Box>

      <TutorialModal isOpen={isOpen} onClose={onClose} videoUrl={videoUrl} />
    </Box>
  );
};

export default SectionHeader;
